// hooks
import createAvatar from 'src/utilities/createAvatar';
import { MAvatar } from './@material-extend';

// ----------------------------------------------------------------------

export default function MyAvatar({
  avatarSource = '',
  name = 'placeholder',
  ...other
}) {
  return (
    <MAvatar
      src={avatarSource}
      alt={name}
      color={avatarSource ? 'default' : createAvatar(name).color}
      {...other}
    >
      {createAvatar(name).name}
    </MAvatar>
  );
}
